<template>
  <div class="map-button-wrapper">
    <button class="button primary-button" @click="toggleModal">
      {{ $t('common.trainers_on_map') }}
    </button>
    <el-dialog
      max-width="1028"
      class="map-wrapper"
      :modal-append-to-body="true"
      :append-to-body="true"
      :visible.sync="dialog"
      :center="true"
      :show-close="true"
      :lock-scroll="true"
      :title="$t('common.trainers_workplaces')"
    >
      <MapModal @clicked="closeMap" />
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MapModal from '~/components/Search/Map/MapModal'

export default {
  name: 'TrainersOnMap',
  components: {
    MapModal
  },
  data: () => ({
    dialog: false,
    markers: []
  }),
  computed: {
    ...mapGetters({
      clubsList: 'search/getClubsList'
    })
  },
  methods: {
    ...mapActions({
      loadTrainersClubs: 'search/LOAD_TRAINERS_CLUBS'
    }),
    closeMap() {
      this.dialog = false
    },
    toggleModal() {
      !this.clubsList && this.loadTrainersClubs()
      this.dialog = true
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/css/variables';
.map-button-wrapper {
  max-width: 190px;
}
.primary-button {
  min-height: 32px;
  max-height: 32px;
  min-width: 189px;
}
</style>
